import { Dialog } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { PublicEmployeeDialogContent } from '~/components/PublicEmployeeDialogContent';
import { People } from '~/services/Http';

import { EmployeeList } from './components/EmployeeList';
import { useSxStyles } from './useStyles';

export interface Props {
  loading: boolean;
  failedToLoad: boolean;
  teamMembers: People.TeamMemberDto[];
  activeMemberId?: number;
  showDetailsForMember?: number;
  handleActiveMemberChange: (employeeId: number) => void;
  handleShowMemberDetails: (employeeId: number) => void;
  handleCloseMemberDetails: () => void;
}

export const Content: React.FC<Props> = ({
  loading,
  failedToLoad,
  teamMembers,
  activeMemberId,
  showDetailsForMember,
  handleActiveMemberChange,
  handleShowMemberDetails,
  handleCloseMemberDetails,
}) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <AsyncContent
      isLoading={loading}
      failedToLoad={failedToLoad}
      noData={!teamMembers.length}
      noDataMessage={t('noTeamMembers')}
      customSxStyles={{ errorMessage: sxStyles.errorMessage }}
    >
      <EmployeeList
        teamMembers={teamMembers}
        activeMemberId={activeMemberId}
        handleActiveMemberChange={handleActiveMemberChange}
        handleShowMemberDetails={handleShowMemberDetails}
      />

      <Dialog
        open={!!showDetailsForMember}
        onClose={handleCloseMemberDetails}
        data-cy="employee-info-dialog"
      >
        {showDetailsForMember && (
          <PublicEmployeeDialogContent
            employeeId={showDetailsForMember}
            onClose={handleCloseMemberDetails}
          />
        )}
      </Dialog>
    </AsyncContent>
  );
};
